import React from 'react';
import LoadingBanner from "../../components/LoadingBanner";
import {Link, useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";
import {useOpportunity} from "../../providers/OpportunityProvider";
import PageError from "../../components/errors/PageError";
import ResourceNotFound from "../../components/errors/ResourceNotFound";
import responsiveHOC from "react-lines-ellipsis/lib/responsiveHOC";
import LinesEllipsis from "react-lines-ellipsis";
import {OppContractTab} from "./OppContractStep";


const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis)
const ActiveOppDetails = (props) => {

    const {auth} = useAuth();
    const {oppId} = useParams();
    const [queryParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();
    const {
        isLoading,
        error,
        changeProps,
        opportunity,
        disabled,
        updateOpportunity,
        refetch,
        onRequest,
        isDisabled
    } = useOpportunity();

    const authType = auth?.canManageClientResourceTalent() ? 'supplier' : 'talent';
    if (!auth) {
        return <div/>;
    }

    if (isLoading) {
        return (
            <div className="talent-portal-page">
                <LoadingBanner message="Loading Project"/>
            </div>
        )
    }
    if (!isLoading && (error || !opportunity)) {
        return (
            <div className="talent-portal-page">
                {error ? (
                    <PageError exitLink={`/${authType}/projects/all`} exitText="Back to Projects"/>
                ) : (
                    <ResourceNotFound type="Project Opportunity" exitLink={`/${authType}/projects/all`} exitText="Back to Projects"/>
                )}
            </div>
        )
    }

    return (
        <div className="talent-portal-page">

            <div className="project-nav min-h-[80px]">

                <div className="project-nav-back hidden md:flex">
                    <Link to={`${authType}`} className="dashboard-home-btn hidden lg:flex">
                        <i className="fa fa-th text-lg text-white"/>
                        <p className="text-white mb-0 mt-2">
                            {TB.trans('talent.dashboard.nav_info')}
                        </p>
                    </Link>
                    <Link to={`/${authType}/projects/all`}>
                        <i className="fa fa-arrow-left mr-2"/>
                        Projects
                    </Link>

                </div>

                <div className="project-nav-info">
                    <div className="opportunity-title-container">
                        <Link className="opportunity-mobile-back-btn lg:hidden"
                              to={opportunity.oppListWithSimilarStatus()}>
                            <i className="fa fa-arrow-left"/>
                        </Link>
                        <ResponsiveEllipsis
                            text={opportunity.project.name}
                            className="opportunity-nav-title"
                            maxLine={2}
                            ellipsis='...'
                            trimRight
                            basedOn='letters'
                        />
                    </div>
                </div>

                <div className="project-nav-type hidden md:flex justify-center">
                    <div>
                        <h5 className="project-type-label">
                            Project Type
                        </h5>
                        <p className="project-type-name">
                            {opportunity.displayType()}
                        </p>
                    </div>
                </div>
            </div>


            {auth.canManageTalent() && opportunity.talentUser() && (
                <div className="nav-alert nav-danger">
                    <p>
                        <i className="fa fa-exclamation-circle"/> Currently Viewing Opportunity
                        as <b>{opportunity.talentUser().fullName()}</b>
                    </p>
                </div>
            )}

            <OppContractTab/>

        </div>
    );
};

export default ActiveOppDetails;